// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToEndOfChain, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadShipTos";
import { CustomAppState } from "@rpsc/App/Store/Reducers";

export const XngPopulateApiParameter: typeof PopulateApiParameter = props => {
    const { showWebOnly = true, ...parameter } = props.parameter as any;
    const newParameter = {
        ...parameter,
        // XNG-Change
        ...(showWebOnly && { expand: [...(parameter.expand || []), "webOnly"] }),
    };
    delete newParameter.onSuccess;
    props.apiParameter = newParameter;
};

// update local state countries
export const XngPopulateCountries: typeof PopulateApiParameter = props => {
    const state = props.getState();
    const billTo = getCurrentBillToState(state);
    const currentCountriesState = { ...((state as CustomAppState).xCommon.countries || {}) };
    props.apiResult.shipTos?.forEach(shipTo => {
        if (shipTo.country?.abbreviation && !currentCountriesState[shipTo.country?.abbreviation]) {
            currentCountriesState[shipTo.country?.abbreviation] = shipTo.country;
        }
    });

    if (billTo.value?.country) {
        currentCountriesState[billTo.value.country.abbreviation] = billTo.value.country;
    }

    props.dispatch({
        type: "xCommon/update",
        data: { key: "countries", value: Object.values(currentCountriesState) },
    } as any);
};

replaceInChain(chain, PopulateApiParameter, XngPopulateApiParameter);
addToEndOfChain(chain, XngPopulateCountries);
